import { useEffect, useRef } from 'react';
import { recordWalkPoint } from '../lib/walkLocation';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const WALK_POINT_INTERVAL_MS = 180000;
const FIX_TIMEOUT_MS = 15000;
const WALK_EVENT = 'curacheck:walk';

// La scheda passeggiata comunica Avvia (id) e Stop (null) al resto dell'app
export const announceWalk = (sessionId) => window.dispatchEvent(new CustomEvent(WALK_EVENT, { detail: sessionId || null }));

// Punti durante la passeggiata, ovunque sia l'assistente nell'app: all'apertura, al ritorno in primo piano
// e ogni 3 minuti solo con l'app visibile. Mai in background, mai richieste di permesso.
export const useWalkForegroundPoints = ({ token, famigliaId, enabled }) => {
  const walkIdRef = useRef(null);

  useEffect(() => {
    if (!enabled || !token || !famigliaId) return undefined;
    let cancelled = false;

    const record = () => {
      if (walkIdRef.current && document.visibilityState === 'visible') {
        recordWalkPoint({ sessionId: walkIdRef.current, token, kind: 'during', timeoutMs: FIX_TIMEOUT_MS });
      }
    };
    const checkAndRecord = async () => {
      if (document.visibilityState !== 'visible') return;
      try {
        const res = await fetch(`${API_URL}/api/gps/active/${famigliaId}`, { headers: { 'X-Family-Token': token } });
        if (!res.ok || cancelled) return;
        walkIdRef.current = (await res.json()).active_session?.id || null;
        record();
      } catch (e) {
        // posizione facoltativa: nessun avviso
      }
    };
    const onWalk = (event) => { walkIdRef.current = event.detail; };

    checkAndRecord();
    document.addEventListener('visibilitychange', checkAndRecord);
    window.addEventListener(WALK_EVENT, onWalk);
    const id = setInterval(record, WALK_POINT_INTERVAL_MS);
    return () => {
      cancelled = true;
      document.removeEventListener('visibilitychange', checkAndRecord);
      window.removeEventListener(WALK_EVENT, onWalk);
      clearInterval(id);
    };
  }, [enabled, token, famigliaId]);
};
